import React from 'react';
import PropTypes from 'prop-types';
import { INPLAY_GAMES_TYPES, TOP_EVENTS_TYPES } from 'core/constants';

import { FormattedTag } from 'components/formatted-tag/formatted-tag';
import { TopEvents } from 'components/top-events/top-events';
import { AllInPlayMenu } from 'components/all-inplay-menu/all-inplay-menu';
import { InplayGames } from 'components/inplay-games/inplay-games';
import { CurrentTime } from 'components/current-time/current-time';
import { PAGE_NAMES } from '../../constants';

import './live.scss';

export const LiveUI = ({
  match: { params: { liveSportId } },
}) => (
  <div className="live position-relative flex-fill">
    <div className="d-flex align-items-center justify-content-between my-2_5 mb-sm-0 mt-lg-3 px-2 px-sm-0">
      <FormattedTag id="left-sidebar.in-play" tag="div" className="live-title font-weight-bolder" />
      <CurrentTime />
    </div>
    <TopEvents coreProps={{ type: TOP_EVENTS_TYPES.LIVE }} />
    <AllInPlayMenu liveSportId={Number(liveSportId)} />
    <InplayGames
      coreProps={{ type: INPLAY_GAMES_TYPES.LIVE }}
      pageName={PAGE_NAMES.LIVE}
      liveSportId={Number(liveSportId)}
      className="mt-1_5"
    />
    <div className="live-bg position-absolute" />
  </div>
);

LiveUI.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      liveSportId: PropTypes.string,
    }),
  }).isRequired,
};

export default LiveUI;
